import { ContentText } from '../../global-types/AdvisoryContent';
import './IconedList.css';

type IconedListProps = {
  texts: ContentText[];
};

function IconedList({ texts }: IconedListProps) {
  return (
    <ul id="advisory-iconed-list">
        {texts.map((text, index) => {
          return (
            <li key={index} className={`if typography ${text.classNames}`}>
              {text.icon && (
                <ids-icon {...{ [text.icon.name]: true, [`${text.icon.group}-16`]: true }} />
              )}
              {text.value}
            </li>
          );
        })}
    </ul>
  );
};

export default IconedList;
